var map = {
	"./Clock-icon.svg": 75835,
	"./NRF.svg": 60772,
	"./PDF-icon.svg": 97334,
	"./accountability-2.svg": 65475,
	"./accountability.svg": 12874,
	"./accounting-analysis.svg": 84066,
	"./accounting-period.svg": 23648,
	"./accumulation.svg": 40195,
	"./age.svg": 29155,
	"./age18plus.svg": 28485,
	"./agility-2.svg": 37388,
	"./agility.svg": 98023,
	"./amount.svg": 67423,
	"./andragogy.svg": 14516,
	"./app-store-download.svg": 1773,
	"./app-store.svg": 71812,
	"./arrow-diagnol.svg": 22198,
	"./arrow-left.svg": 11749,
	"./arrow-right.svg": 17124,
	"./arrow-square-out-bold.svg": 71613,
	"./arrow-square-out.svg": 14032,
	"./arrow-up-right.svg": 805,
	"./article.svg": 24191,
	"./assessment.svg": 79814,
	"./assurance.svg": 78308,
	"./balancer.svg": 63639,
	"./bank.svg": 99300,
	"./bell-icon.svg": 88679,
	"./benefits.svg": 29147,
	"./bill-medical.svg": 85279,
	"./boy.svg": 28848,
	"./bulb.svg": 99955,
	"./business-criminal.svg": 58069,
	"./cake.svg": 32917,
	"./calculate-life-insurance-cover.svg": 57370,
	"./calculate-premium.svg": 42263,
	"./calculator-bold.svg": 96639,
	"./calculator.svg": 70825,
	"./calendar-1.svg": 85730,
	"./calendar-lite.svg": 4336,
	"./calendar.svg": 98613,
	"./capital.svg": 57492,
	"./card.svg": 79981,
	"./career-completed.svg": 19519,
	"./career-maturity.svg": 56355,
	"./career-start.svg": 46929,
	"./cash-flow.svg": 2908,
	"./cash-money.svg": 15298,
	"./check-circle-bg.svg": 55406,
	"./check-circle.svg": 58302,
	"./check-claim-status.svg": 90404,
	"./check.svg": 65279,
	"./child-care-benefit-icon.svg": 32209,
	"./child-education-1.svg": 21788,
	"./child-education.svg": 94101,
	"./circle-check.svg": 10503,
	"./circle-right-arrow.svg": 70523,
	"./city-icon-1.svg": 40535,
	"./city-icon-2.svg": 67492,
	"./city-icon-3.svg": 142,
	"./city-icon-4.svg": 1037,
	"./city-icon-5.svg": 60549,
	"./city-icon-6.svg": 67163,
	"./city-icon-7.svg": 52022,
	"./city-icon-8.svg": 27374,
	"./claim-1.svg": 99730,
	"./claim.svg": 89916,
	"./clock.svg": 87570,
	"./close.svg": 63363,
	"./coin.svg": 92801,
	"./collaborate.svg": 69240,
	"./compare.svg": 48642,
	"./comparison.svg": 84808,
	"./contact-details.svg": 26038,
	"./contact-us.svg": 91192,
	"./contact-white.svg": 28414,
	"./contact.svg": 59095,
	"./content.svg": 39971,
	"./contingency.svg": 29127,
	"./correction.svg": 46687,
	"./coverage.svg": 7760,
	"./credibility.svg": 32846,
	"./customer-experience.svg": 39424,
	"./customer-service.svg": 11499,
	"./date.svg": 97611,
	"./deadline.svg": 19930,
	"./death.svg": 4292,
	"./deposit.svg": 98702,
	"./diagnosis.svg": 7102,
	"./did-you-know.svg": 29994,
	"./disability.svg": 82277,
	"./doctor.svg": 91099,
	"./doctors-note.svg": 64510,
	"./documents-1.svg": 68688,
	"./documents.svg": 55337,
	"./down-arrow-blue.svg": 94114,
	"./down-arrow.svg": 37738,
	"./download.svg": 87607,
	"./drop-down-caret.svg": 31113,
	"./drop-up-caret.svg": 39393,
	"./drugs.svg": 6102,
	"./e-nach-registeration.svg": 38925,
	"./economy.svg": 58608,
	"./edit.svg": 87021,
	"./education-1.svg": 7982,
	"./education.svg": 13915,
	"./email.svg": 71936,
	"./error-page.svg": 35843,
	"./expenses-1.svg": 57413,
	"./expenses.svg": 86615,
	"./external-link.svg": 42384,
	"./eye-stroke.svg": 40979,
	"./eye-with-box.svg": 25899,
	"./eye.svg": 38887,
	"./facebook.svg": 21014,
	"./family-1.svg": 88140,
	"./family.svg": 43888,
	"./filter.svg": 28914,
	"./finance-options.svg": 18967,
	"./financial-goals.svg": 41807,
	"./financial-immunity.svg": 42977,
	"./financial-protection.svg": 30805,
	"./financial-ratios.svg": 70853,
	"./financial-risk-1.svg": 82265,
	"./financial-risk-2.svg": 29612,
	"./financial-risk-3.svg": 48792,
	"./financial-security.svg": 13126,
	"./financial-support.svg": 18377,
	"./fixed-deposit.svg": 25214,
	"./flexible-investment.svg": 21419,
	"./forms-check.svg": 88190,
	"./frame.svg": 26181,
	"./get-it-on-google-play.svg": 70230,
	"./get-quote.svg": 44749,
	"./girl.svg": 52690,
	"./google-play.svg": 80342,
	"./graph.svg": 73139,
	"./grievance-redressal.svg": 7706,
	"./group-1.svg": 36076,
	"./group-2.svg": 8933,
	"./group-3.svg": 91831,
	"./group-4.svg": 88266,
	"./group-5.svg": 52926,
	"./group.svg": 55338,
	"./growing-up.svg": 73808,
	"./growth.svg": 96882,
	"./guaranteed-returns.svg": 45518,
	"./hamburger-icon.svg": 19290,
	"./hands-meet.svg": 38601,
	"./hazardous.svg": 82874,
	"./health-care-1.svg": 53560,
	"./health-care-2.svg": 81382,
	"./health-care.svg": 29102,
	"./health-insurance.svg": 12732,
	"./illness-40.svg": 6733,
	"./income-1.svg": 85471,
	"./income-2.svg": 59512,
	"./income-replacement.svg": 92772,
	"./income.svg": 74286,
	"./incorrect-document.svg": 97375,
	"./info.svg": 83546,
	"./instagram.svg": 22409,
	"./insurance-note.svg": 5586,
	"./insurance-policy.svg": 96596,
	"./insured-person.svg": 32907,
	"./invesment.svg": 94087,
	"./investment-1.svg": 73198,
	"./investment-plans.svg": 30506,
	"./investment.svg": 64030,
	"./iselect-smart.svg": 94340,
	"./issue-duplicate-policy.svg": 46558,
	"./layer.svg": 17542,
	"./left-caret.svg": 6969,
	"./life-cover.svg": 49040,
	"./life-expectancy.svg": 33212,
	"./life-insurance.svg": 66739,
	"./link-icon.svg": 28759,
	"./link.svg": 82339,
	"./linkedin-new.svg": 3554,
	"./linkedin.svg": 10007,
	"./liquidity.svg": 95800,
	"./list.svg": 81121,
	"./locate-white.svg": 89089,
	"./location.svg": 71357,
	"./logo-canara-hsbc.svg": 50422,
	"./logo-canara.svg": 64916,
	"./logo-hsbc.svg": 54376,
	"./mail-white.svg": 89515,
	"./manager.svg": 6767,
	"./market-linked.svg": 2533,
	"./medical-illness.svg": 64466,
	"./mic.svg": 11776,
	"./mobile-number-white.svg": 5866,
	"./money-back.svg": 35440,
	"./money-bag.svg": 50091,
	"./money-document.svg": 43010,
	"./money-hand.svg": 61558,
	"./money-insurance.svg": 1257,
	"./money-withdrawal.svg": 62616,
	"./money.svg": 60833,
	"./moneyback-refund.svg": 80491,
	"./network.svg": 16630,
	"./no-internet.svg": 25365,
	"./nominee.svg": 57625,
	"./note.svg": 30299,
	"./old-person.svg": 40763,
	"./one-crore.svg": 81592,
	"./paper-money.svg": 75029,
	"./parents.svg": 86743,
	"./patient.svg": 94235,
	"./pay-premium-save.svg": 87728,
	"./pay-premium.svg": 47756,
	"./payment.svg": 40317,
	"./pdf-csr.svg": 35365,
	"./pdf-icon.svg": 30916,
	"./pending-requirement.svg": 99453,
	"./person.svg": 88918,
	"./pie-chart-document.svg": 53737,
	"./planner.svg": 98937,
	"./plus.svg": 51611,
	"./policy-1.svg": 94541,
	"./policy.svg": 63543,
	"./portfolio-1.svg": 36379,
	"./portfolio.svg": 88466,
	"./post.svg": 45976,
	"./power-of-compouding.svg": 82602,
	"./premium-returns.svg": 86118,
	"./print-receipt.svg": 9123,
	"./protection-plans.svg": 84631,
	"./published-date.svg": 70252,
	"./published_date.svg": 44854,
	"./qr-code.svg": 15677,
	"./rate-of-return.svg": 71151,
	"./ratio.svg": 18868,
	"./read.svg": 63855,
	"./register-a-complaint.svg": 96934,
	"./register-claim.svg": 61626,
	"./register-claims.svg": 10286,
	"./reimbursements.svg": 21367,
	"./replay.svg": 16561,
	"./report.svg": 49062,
	"./research.svg": 27019,
	"./respect-2.svg": 82677,
	"./respect.svg": 2782,
	"./resume-journey.svg": 73114,
	"./retirement-2.svg": 29281,
	"./retirement-income.svg": 84446,
	"./retirement-plans.svg": 25328,
	"./retirement.svg": 16316,
	"./return-on-investment.svg": 7224,
	"./return.svg": 60023,
	"./revenue.svg": 44231,
	"./reviews.svg": 62481,
	"./right-caret.svg": 88737,
	"./risk.svg": 2509,
	"./rupee.svg": 66609,
	"./rush.svg": 32286,
	"./salary.svg": 58344,
	"./save-tax.svg": 71832,
	"./save.svg": 79894,
	"./saving-1.svg": 40919,
	"./saving-2.svg": 69988,
	"./saving-3.svg": 37491,
	"./saving.svg": 78339,
	"./search.svg": 71163,
	"./secure-money.svg": 25566,
	"./service-booklet.svg": 3514,
	"./share.svg": 47848,
	"./starts-at.svg": 14458,
	"./stepPatternMask.svg": 6828,
	"./steps-arrows-red.svg": 75472,
	"./steps-arrows.svg": 82718,
	"./suicide.svg": 65115,
	"./switching.svg": 96009,
	"./tags.svg": 59427,
	"./tax-savings-1.svg": 183,
	"./tax-savings-2.svg": 9224,
	"./tax-savings.svg": 18104,
	"./tax.svg": 43889,
	"./term-life-insurance.svg": 56862,
	"./term-plan.svg": 90725,
	"./term.svg": 18393,
	"./thermometer.svg": 82916,
	"./timer.svg": 19035,
	"./track-complaint.svg": 41684,
	"./track-complaint2.svg": 47823,
	"./trash.svg": 72118,
	"./trust.svg": 64058,
	"./unit-linked-insurance-plans.svg": 18637,
	"./up-arrow.svg": 93146,
	"./update-life-certificate.svg": 26706,
	"./user-1.svg": 25804,
	"./user-centric.svg": 66522,
	"./user-icon.svg": 2359,
	"./user-white.svg": 67432,
	"./usp-wealth-creation.svg": 37193,
	"./uspCard-GuaranteedIncome.svg": 70881,
	"./uspCard-buildYourChildFuture.svg": 51087,
	"./uspCard-critical-illness.svg": 32655,
	"./uspCard-getGuaranteed.svg": 31760,
	"./uspCard-oneCrore.svg": 72903,
	"./uspCard-saveOnTax.svg": 26952,
	"./uspCard-savingLifeCover.svg": 92487,
	"./uspCard-switchBetweenFunds.svg": 25103,
	"./uspCard-wholeLifeCover.svg": 12126,
	"./uspcard-returnOfPremium.svg": 81358,
	"./vector-1.svg": 97890,
	"./vector.svg": 60420,
	"./video-control-play.svg": 61467,
	"./video-play-outline.svg": 10235,
	"./view.svg": 43567,
	"./war.svg": 13090,
	"./wealth-creation.svg": 58218,
	"./wedding.svg": 16299,
	"./whatsapp.svg": 714,
	"./wheelchair.svg": 718,
	"./withdrawal.svg": 19336,
	"./x-circle.svg": 57177,
	"./xLogo.svg": 38904,
	"./years-99.svg": 61178,
	"./young-term.svg": 28576,
	"./youtube.svg": 6794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91213;